import React from 'react';
import { Checkbox as UIBricksCheckbox } from '@makemydeal/ui-bricks/dist/cox';

const Checkbox: React.FC<any> = (props) => {
    return <UIBricksCheckbox {...props} />;
};

export default Checkbox;
